module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAABU0lEQVR42o1RPUvEQBCNaGHhB36h/0CwsRDkwELwF4iC2NipsJtLdmfnLrkciPsPBG39BbERsVWwVLBVEcVSbPwLcV5xaORiHAi7mXlv3szboC6axm1qQw/K0JOyvB78J8KYtpVxH5FzjaZtr+CuLW/8rWRbazp27xHzQi8nDRZVTEWapuN9SRHRMgDGJPNRls0kSTLaqyGvjdvrS9TWtaR4Y0x3VlQfvffDyEvuBMQ8zwfLO1mnBHjNzNOKeUnF7iU03EVNWZeJQc/a+5GyiiGW7z6k1lZo7a6AXqEshhxJswO4qtvtuRJJiim6hVk2pTqdCbm/CfgQu0kzLSOeYtdf4/EO5sY++AcBYLiJfKXtKCqi1R+WN3BCFQ9fQYMCnQvgsiiKge+Hd8cy3h3cqySK1UPS/QomENGkinlf3LyNvB8L6gLvJMpnQviU8wKW13G+APlOo5STImQOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/n-source_1x.png
// module id = 2312
// module chunks = 0